export enum PartnerScoreChannel {
  PARTNERSCORE = 'partnerscore',
  CSATSCORE = 'csatscore',
  CESSCORE = 'cesscore',
  NPSSCORE = 'npsscore',
}

export interface PartnerScoreChannelConfig {
  label: string;
  averageScore: number;
  changeScore: number | string;
  link: string;
  channel: PartnerScoreChannel;
  tagline: string;
  normalizedScore?: string;
}
